// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".GJAFQgZbWUk6GA9u8gDw {\n\tpadding-top: 30px;\n}\n\n.RfBqS6ScNGoeuQe63O3D {\n\tmargin-top: 150px;\n}\n", "",{"version":3,"sources":["webpack://./client/src/screens/estimates/details/styles/FuelEuPenaltyCalculation.module.css"],"names":[],"mappings":"AAAA;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB","sourcesContent":[".fuelEuCalculation {\n\tpadding-top: 30px;\n}\n\n.fuelEuCalculationPenalty {\n\tmargin-top: 150px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fuelEuCalculation": "GJAFQgZbWUk6GA9u8gDw",
	"fuelEuCalculationPenalty": "RfBqS6ScNGoeuQe63O3D"
};
export default ___CSS_LOADER_EXPORT___;
